import { SPELL_ID } from '../ids/spell-id'
import { Spell, FightPlayer } from 'web/data/models'
import { TALENT_ID } from '../ids/talent-id'
import { CooldownResolver } from 'web/engine/cooldowns/core-resolver'

type ResolverMap = { [spellId: string]: CooldownResolver }

export const SPELL_RESOLVERS: ResolverMap = {

    [SPELL_ID.DRUID.RESTO.TRANQ]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cd = spell.cooldown

        if (spell.id === SPELL_ID.DRUID.RESTO.TRANQ) {
            if (fightPlayer.talentIds.includes(TALENT_ID.DRUID.RESTO.INNER_PEACE)) {
                cd = cd - 60
            }
        }

        return cd
    },

}
